import { render, staticRenderFns } from "./TraceabilityFilter.vue?vue&type=template&id=c0d64152&scoped=true"
import script from "./TraceabilityFilter.vue?vue&type=script&lang=js"
export * from "./TraceabilityFilter.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityFilter.vue?vue&type=style&index=0&id=c0d64152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d64152",
  null
  
)

export default component.exports